var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-5 flex items-center h-full w-full",class:("lang-" + (_vm.$i18n.locale))},[_c('Nuxt'),_vm._v(" "),_c('confirmation-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }